import { Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';

export const routes: Routes = [
  {
    path: 'login/callback',
    component: OktaCallbackComponent,
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./feature/login/login.routes').then((x) => x.LOGIN_ROUTES),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./feature/home/home.routes').then((x) => x.HOME_ROUTES),
  },
  {
    path: 'exception/:type',
    loadChildren: () =>
      import('./feature/exception/exception.routes').then(
        (x) => x.EXCEPTION_ROUTES,
      ),
  },
  {
    path: 'capability-framework',
    loadChildren: () =>
      import('./feature/capability-framework/capability-framework.routes').then(
        (x) => x.CAPABILITY_FRAMEWORK_ROUTES,
      ),
  },
  {
    path: 'competency-assessments',
    loadChildren: () =>
      import('./feature/claims/claims.routes').then((x) => x.CLAIMS_ROUTES),
  },
  {
    path: 'claims',
    loadChildren: () =>
      import('./feature/claims/claims-legacy-redirect.routes').then(
        (x) => x.CLAIMS_LEGACY_REDIRECT_ROUTES,
      ),
  },
  {
    path: 'matrices',
    loadChildren: () =>
      import('./feature/matrices/matrices.routes').then((x) => x.MATRIX_ROUTES),
  },
  {
    path: 'group-management',
    loadChildren: () =>
      import('./feature/groups-new/groups.routes').then(
        (x) => x.GROUP_MANAGEMENT_ROUTES,
      ),
  },
  {
    path: 'events',
    loadChildren: () =>
      import('./feature/events/events.routes').then((x) => x.EVENTS_ROUTES),
  },
  {
    path: 'job-role',
    loadChildren: () =>
      import('./feature/job-role/job-role.routes').then(
        (x) => x.JOB_ROLE_ROUTES,
      ),
  },
  {
    path: 'role-management',
    loadChildren: () =>
      import('./feature/role-management/role-management.routes').then(
        (x) => x.ROLE_MANAGEMENT_ROUTES,
      ),
  },
  {
    path: 'person',
    loadChildren: () =>
      import('./feature/person/person.routes').then((x) => x.PERSON_ROUTES),
  },
  {
    path: 'training-management',
    loadChildren: () =>
      import('./feature/training-management/training-management.routes').then(
        (x) => x.LEARNING_MANAGEMENT_ROUTES,
      ),
  },
  {
    path: 'capability-passport',
    loadChildren: () =>
      import('./feature/competency-passport/capability-passport.routes').then(
        (x) => x.PASSPORT_ROUTES,
      ),
  },
  {
    path: 'assessment-checklists',
    loadChildren: () =>
      import(
        './feature/observation-checklists/observation-checklists.routes'
      ).then((x) => x.OBSERVATION_ROUTES),
  },
  {
    path: 'assessment-library',
    loadChildren: () =>
      import('./feature/criteria/criteria.routes').then(
        (m) => m.CRITERION_ROUTES,
      ),
  },
  {
    path: 'competency-library',
    loadChildren: () =>
      import('./feature/competency-library/competency-library.routes').then(
        (x) => x.COMPETENCY_LIBRARY_ROUTES,
      ),
  },
  {
    path: 'competency-management',
    loadChildren: () =>
      import(
        './feature/competency-management/competency-management.routes'
      ).then((x) => x.COMPETENCY_MANAGEMENT_ROUTES),
  },
  {
    path: 'notification-settings',
    loadChildren: () =>
      import('./feature/notifications/notifications.routes').then(
        (m) => m.NOTIFICATIONS_ROUTES,
      ),
  },
  {
    path: 'proficiency-level-groups',
    loadChildren: () =>
      import('./feature/level-group-library/level-group-library.routes').then(
        (m) => m.LEVEL_GROUP_LIBRARY_ROUTES,
      ),
  },
  {
    path: 'level-group-management',
    loadChildren: () =>
      import(
        './feature/level-group-management/level-group-management.routes'
      ).then((x) => x.LEVEL_GROUP_MANAGEMENT_ROUTES),
  },
  {
    path: 'development-actions',
    loadChildren: () =>
      import('./feature/development-actions/development-actions.routes').then(
        (x) => x.DEVELOPMENT_ACTIONS_ROUTES,
      ),
  },
  // Legacy bookmarked URLs, renamed as part of ADO #4295.
  { path: 'notifications', redirectTo: '/notification-settings' },
  { path: 'level-group-library', redirectTo: '/proficiency-level-groups' },
  { path: 'proficiency-levels', redirectTo: '/proficiency-level-groups' },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: '**',
    loadChildren: () =>
      import('./feature/page-not-found/page-not-found.routes').then(
        (x) => x.PAGE_NOT_FOUND_ROUTES,
      ),
  },
];
